module.exports = __webpack_public_path__ + "img/Sommelier_MarianaRivera.fccf24d3.png";